import * as Maps          from '../../../components/blocks/map/main';
import * as DirectContact from '../../../components/blocks/direct-contact/main';
import * as Logos         from '../../../components/sections/logo-carousel/main';

Maps.init();
Logos.init();
DirectContact.init();
